module.exports = __webpack_public_path__ + "static/media/filter-checkbox-checked.e7b62b5d.svg";